import { getTranslationKeysHook } from '@bringg-frontend/utils';

export const translateKeys = {
	uploadTitle: 'SERVICE_AREA.UPLOAD_TITLE',
	uploadDescription: 'SERVICE_AREA.UPLOAD_DESCRIPTION',
	upload: 'GLOBAL.UPLOAD',
	uploadFailed: 'SERVICE_AREA.UPLOAD_FAILED',
	templateName: 'SERVICE_AREA.TEMPLATE_NAME',
	progressTitle: 'SERVICE_AREA.PROGRESS_TITLE',
	downloadErrorsFile: 'SERVICE_AREA.DOWNLOAD_ERRORS_FILE',
	parsingFile: 'SERVICE_AREA.PARSING_FILE',
	failedToFetchStatus: 'SERVICE_AREA.FAILED_TO_FETCH_STATUS'
};

export default getTranslationKeysHook<typeof translateKeys>(translateKeys);
